<div class="unauthorized-container">
  <mat-toolbar class="toolbar-main">
    <a [href]="return_to_ecolab" target="_blank" rel="noopener noreferrer">
      <img alt="Ecolab" src="{{ ecolabLogo }}" />
    </a>
  </mat-toolbar>

  <div class="content-wrapper">
    <div class="error-code">401</div>
    <div class="content-overlay">
      <h1>Unauthorized User</h1>
      <p>
        We can't log you in at this time because your account does not have
        authorization to view the Enterprise Business Review application.
      </p>
      <a [href]="return_to_ecolab" target="_blank" rel="noopener noreferrer">
        <button mat-raised-button>Return to Ecolab.com</button>
      </a>
    </div>
  </div>
</div>
